import { DbTimestampGenerated } from '@harvestiq/utils';
import { zTimestamp } from '@harvestiq/zod';
import { expectTypeOf } from 'expect-type';
import { GeneratedAlways, Insertable, Selectable, Updateable } from 'kysely';
import { z } from '@harvestiq/zod';
import {
  ClaimDocumentsUploadStatuses,
  ClaimDocumentUploadStatus,
} from './claim-document-upload-statuses';
import {
  ClaimDocumentsTypes,
  ClaimDocumentTypes,
} from './claim-document-types';

export interface ClaimDocumentsTable {
  id: GeneratedAlways<string>;
  claimId: string;
  filename: string;
  mediaType: string;
  fileSizeBytes: number;
  s3Key: string;
  type: ClaimDocumentTypes;
  uploadStatus: ClaimDocumentUploadStatus;
  uploadedBy: string | null;
  uploadedAt: DbTimestampGenerated;
  createdAt: DbTimestampGenerated;
  updatedAt: DbTimestampGenerated;
}

export type DbClaimDocument = Selectable<ClaimDocumentsTable>;
export type DbClaimDocumentInsert = Insertable<ClaimDocumentsTable>;
export type DbClaimDocumentUpdate = Updateable<ClaimDocumentsTable>;

export const dbClaimDocumentSchema = z.object({
  id: z.string().uuid(),
  claimId: z.string().uuid(),
  filename: z.string(),
  mediaType: z.string(),
  fileSizeBytes: z.number().int(),
  s3Key: z.string(),
  type: z.nativeEnum(ClaimDocumentsTypes),
  uploadStatus: z.nativeEnum(ClaimDocumentsUploadStatuses),
  uploadedBy: z.string().nullable(),
  uploadedAt: z.coerce.date(),
  createdAt: z.coerce.date(),
  updatedAt: z.coerce.date(),
});
expectTypeOf<DbClaimDocument>().toMatchTypeOf<
  z.output<typeof dbClaimDocumentSchema>
>();

export const dbClaimDocumentInsertSchema = dbClaimDocumentSchema
  .omit({
    id: true,
    createdAt: true,
    updatedAt: true,
  })
  .extend({
    claimId: z.string().uuid(),
    type: z.nativeEnum(ClaimDocumentsTypes),
    uploadStatus: z.nativeEnum(ClaimDocumentsUploadStatuses),
    uploadedAt: zTimestamp().optional(),
    createdAt: zTimestamp().optional(),
    updatedAt: zTimestamp().optional(),
  });
type CreateClaimDocumentFromSchema = z.input<
  typeof dbClaimDocumentInsertSchema
>;
expectTypeOf<keyof CreateClaimDocumentFromSchema>().toEqualTypeOf<
  keyof DbClaimDocumentInsert
>();
expectTypeOf<CreateClaimDocumentFromSchema>().toMatchTypeOf<DbClaimDocumentInsert>();

export const dbClaimDocumentUpdateSchema =
  dbClaimDocumentInsertSchema.partial();
type UpdateClaimDocumentFromSchema = z.input<
  typeof dbClaimDocumentUpdateSchema
>;
expectTypeOf<keyof UpdateClaimDocumentFromSchema>().toEqualTypeOf<
  keyof DbClaimDocumentUpdate
>();
expectTypeOf<UpdateClaimDocumentFromSchema>().toMatchTypeOf<DbClaimDocumentUpdate>();
